(function () {
  const selectors = {
    config: '[data-kit-builder-config]',
    form: '[data-kit-builder-form]',
    notice: '[data-kit-builder-notice]',
    panel: '[data-kit-builder-panel]',
    panelContent: '[data-kit-builder-panel-content]',
    panelSummary: '[data-kit-builder-panel-summary]',
    panelToggle: '[data-kit-builder-panel-toggle]',
    postAddActions: '[data-kit-builder-post-add-actions]',
    postAddMessage: '[data-kit-builder-post-add-message]',
    roles: '[data-kit-builder-roles]',
    size: '[data-kit-builder-size]',
    status: '[data-kit-builder-status]',
    submit: '[data-kit-builder-submit]',
    summary: '[data-kit-builder-summary]',
    tools: '[data-kit-builder-tools]',
    toolsPanel: '[data-kit-builder-tools-panel]',
    versionGroup: '[data-kit-builder-versions]',
    versionPanel: '[data-kit-builder-version-panel]',
    versionTab: '[data-kit-builder-version-tab]',
    viewCart: '[data-kit-builder-view-cart]',
    yarnAddOn: '[data-kit-builder-yarn-addon]',
    yarnAddOns: '[data-kit-builder-yarn-add-ons]',
    yarnAddOnsPanel: '[data-kit-builder-yarn-add-ons-panel]',
    yarnRoleTab: '[data-kit-builder-yarn-role-tab]',
    yarnSummary: '[data-kit-builder-yarn-summary]',
    addAnother: '[data-kit-builder-add-another]',
  };

  const defaultLabels = {
    summaryNotConfigured: 'This product needs a pattern and configured yarns to enable the kit builder.',
    summaryNoSizes: 'The selected pattern does not have yarn amounts configured yet.',
    summaryKitLabel: 'Kit:',
    summaryIncludedHeading: 'Included',
    summaryAddOnsHeading: 'Add-ons',
    summarySizeLabel: 'Size:',
    summaryEstimatedSubtotal: 'Estimated subtotal:',
    versionLabel: 'Version',
    addButton: 'Add kit to cart',
    addButtonUnavailable: 'Sold out',
    addButtonAdding: 'Adding to cart...',
    kitAlreadyInCart: 'You already have this kit in your cart',
    viewCart: 'View cart',
    addAnotherKit: 'Add another kit',
    chooseSize: 'Choose a size',
    chooseColour: 'choose a colour',
    noColoursForQuantity: 'no colours have enough stock for [quantity]',
    unavailableStockTooltip: '[title]: only [count] skeins available',
    unavailableStockTooltipOne: '[title]: only 1 skein available',
    unavailableStockTooltipFew: '[title]: only [count] skeins available',
    unavailableStockTooltipMany: '[title]: only [count] skeins available',
    unavailableStockEmptyTooltip: '[title]: unavailable',
    hiddenColour: ' colour',
    requiresStockHint: 'Requires [quantity]. Unavailable colours do not have enough stock for this size.',
    emptyNoColours: 'No colours have enough stock for [quantity].',
    patternRole: 'Pattern',
    yarnAddOnRole: 'Extra yarn',
    yarnAddOnQuantityLabel: 'Extra skeins',
    yarnAddOnStockHint: 'Up to [quantity] extra skeins available.',
    yarnAddOnUnlimitedStockHint: 'Extra skeins available.',
    emptyYarnAddOns: 'Choose yarn colours first.',
    toolRole: 'Tools',
    toolNoteName: 'Note',
    toolNoteValue: 'Needles for [pattern]',
    emptyTools: 'No matching tools are configured for this pattern.',
    componentFallback: 'Component',
    itemQuantity: '[title] x [quantity]',
    errorCouldNotAdd: 'Could not add this kit.',
    errorHeading: 'Could not add kit to cart.',
    errorKitStockUnavailable: 'Some kit contents do not have enough stock. The kit was not added to your cart.',
    errorHttpStatus: 'HTTP status',
    errorShopifyStatus: 'Shopify status',
    errorShopifyMessage: 'Shopify message',
    errorShopifyDescription: 'Shopify description',
    errorShopifyErrors: 'Shopify errors',
    errorKitIdAttempted: 'Kit ID attempted',
    attemptedLines: 'Attempted lines:',
    validationMissingData: 'Missing required product data: a pattern and configured yarns are required.',
    validationPatternUnavailable: 'The pattern product variant is not available.',
    validationChooseSize: 'Choose a size.',
    validationNoColourStock: '[role]: no colour has enough stock for [quantity].',
    validationChooseColour: '[role]: choose a colour.',
    validationSelectedColourStock: '[role]: selected colour does not have enough stock for [quantity].',
    validationYarnAddOnStock: '[role]: selected colour does not have enough stock for [quantity] extra skeins.',
    validationHeading: 'Kit is not ready to add.',
    statusReady: 'Kit builder ready.',
    statusAdding: 'Adding kit to cart...',
    successNotice: 'Kit added to cart. You can review the individual components in the cart.',
    statusAdded: 'Kit added to cart.',
    statusNotAdded: 'Kit was not added.',
    statusNotReady: 'Kit is not ready to add.',
  };

  function money(cents, config) {
    const locale = config.locale || document.documentElement.lang || 'en';
    const currency = config.currency || 'PLN';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      }).format((cents || 0) / 100);
    } catch (error) {
      return `${((cents || 0) / 100).toFixed(2)} ${currency}`;
    }
  }

  function parseConfig(builder) {
    const script = builder.querySelector(selectors.config);
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('Kit builder config is invalid.', error);
      return null;
    }
  }

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    }[character]));
  }

  function label(config, key, replacements) {
    const labels = config && config.labels ? config.labels : {};
    let value = labels[key] || defaultLabels[key] || '';

    Object.entries(replacements || {}).forEach(([replacementKey, replacementValue]) => {
      value = value.replaceAll(`[${replacementKey}]`, replacementValue);
    });

    return value;
  }

  function isPolishLocale(config) {
    const locale = config && config.locale ? config.locale : document.documentElement.lang || '';
    return String(locale).toLowerCase().startsWith('pl');
  }

  function polishSkeinWord(quantity) {
    const absoluteQuantity = Math.abs(Number(quantity || 0));
    const lastDigit = absoluteQuantity % 10;
    const lastTwoDigits = absoluteQuantity % 100;

    if (absoluteQuantity === 1) return 'motek';
    if (lastDigit >= 2 && lastDigit <= 4 && !(lastTwoDigits >= 12 && lastTwoDigits <= 14)) return 'motki';
    return 'motków';
  }

  function skeinQuantityLabel(config, quantity) {
    const quantityNumber = Number(quantity || 0);
    if (isPolishLocale(config) && Number.isInteger(quantityNumber)) {
      return `${quantityNumber} ${polishSkeinWord(quantityNumber)}`;
    }

    return quantityNumber === 1 ? '1 skein' : `${quantityNumber} skeins`;
  }

  function yarnQuantityReplacements(config, quantity, replacements) {
    return {
      ...(replacements || {}),
      quantity,
      skeinQuantity: skeinQuantityLabel(config, quantity),
    };
  }

  function labelledLine(config, key, value) {
    return `${label(config, key)}: ${value}`;
  }

  function hasLabel(config, key) {
    const labels = config && config.labels ? config.labels : {};
    return Boolean(labels[key] || defaultLabels[key]);
  }

  function stockTooltipLabelKey(config, availableQuantity) {
    if (availableQuantity === 0) return 'unavailableStockEmptyTooltip';

    const locale = config && config.locale ? config.locale : document.documentElement.lang || 'en';
    const categoryKeys = {
      one: 'unavailableStockTooltipOne',
      few: 'unavailableStockTooltipFew',
      many: 'unavailableStockTooltipMany',
    };

    let category = 'other';
    try {
      category = new Intl.PluralRules(locale).select(availableQuantity);
    } catch (error) {
      category = availableQuantity === 1 ? 'one' : 'other';
    }

    const categoryKey = categoryKeys[category];
    return categoryKey && hasLabel(config, categoryKey) ? categoryKey : 'unavailableStockTooltip';
  }

  function usesSingleYarnRole(config) {
    return config && Array.isArray(config.roles) && config.roles.length === 1;
  }

  function roleDisplayLabel(config, role) {
    return usesSingleYarnRole(config) ? role.productTitle : role.label;
  }

  function patternDisplayTitle(config) {
    return `${config.pattern.productTitle} (PDF w jęz. polskim)`;
  }

  function setStatus(builder, message) {
    const status = builder.querySelector(selectors.status);
    if (status) status.textContent = message;
  }

  function setNotice(builder, message, type) {
    const notice = builder.querySelector(selectors.notice);
    if (!notice) return;

    notice.textContent = message || '';
    notice.hidden = !message;
    notice.dataset.type = type || '';
  }

  function setNoticeHTML(builder, html, type) {
    const notice = builder.querySelector(selectors.notice);
    if (!notice) return;

    notice.innerHTML = html || '';
    notice.hidden = !html;
    notice.dataset.type = type || '';
  }

  function setSubmitLabel(submit, config, key) {
    if (!submit) return;

    submit.textContent = label(config, key);
  }

  function setPostAddActionsVisible(builder, visible) {
    const submit = builder.querySelector(selectors.submit);
    const postAddActions = builder.querySelector(selectors.postAddActions);

    if (submit) submit.hidden = visible;
    if (postAddActions) postAddActions.hidden = !visible;
  }

  function postAddActionsVisible(builder) {
    const postAddActions = builder.querySelector(selectors.postAddActions);
    return Boolean(postAddActions && !postAddActions.hidden);
  }

  function syncPostAddActions(builder, config) {
    const message = builder.querySelector(selectors.postAddMessage);
    const viewCart = builder.querySelector(selectors.viewCart);
    const addAnother = builder.querySelector(selectors.addAnother);

    if (message) message.textContent = label(config, 'kitAlreadyInCart');
    if (viewCart) {
      viewCart.textContent = label(config, 'viewCart');
      viewCart.href = config.routes.cartPage;
    }
    if (addAnother) addAnother.textContent = label(config, 'addAnotherKit');
  }

  function setActiveVersion(group, versionId) {
    const tabs = group.querySelectorAll(selectors.versionTab);
    const panels = group.querySelectorAll(selectors.versionPanel);

    tabs.forEach((tab) => {
      const isActive = tab.getAttribute('data-kit-builder-version-tab') === versionId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-pressed', String(isActive));
    });

    panels.forEach((panel) => {
      const isActive = panel.getAttribute('data-kit-builder-version-panel') === versionId;
      panel.hidden = !isActive;
      if (isActive) {
        panel.setAttribute('data-testid', 'kit-builder');
      } else {
        panel.removeAttribute('data-testid');
      }
    });
  }

  function initVersionGroup(group) {
    const firstPanel = group.querySelector(selectors.versionPanel);
    if (!firstPanel) return;

    const activePanel = group.querySelector(`${selectors.versionPanel}:not([hidden])`) || firstPanel;
    setActiveVersion(group, activePanel.getAttribute('data-kit-builder-version-panel'));

    group.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const tab = event.target.closest(selectors.versionTab);
      if (!tab || !group.contains(tab)) return;

      setActiveVersion(group, tab.getAttribute('data-kit-builder-version-tab'));
    });
  }

  function showNoticeHTML(builder, html, type) {
    setNoticeHTML(builder, html, type);

    const notice = builder.querySelector(selectors.notice);
    if (!notice || notice.hidden) return;

    notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
    notice.focus({ preventScroll: true });
  }

  function getSelectedSize(config, sizeSelect) {
    return config.sizes.find((size) => size.id === sizeSelect.value);
  }

  function getSelectedVariant(builder, roleId, config) {
    const checkedInput = builder.querySelector(`[data-kit-builder-role="${roleId}"]:checked`);
    const select = builder.querySelector(`select[data-kit-builder-role="${roleId}"]`);
    const selectedValue = checkedInput ? checkedInput.value : select ? select.value : '';
    const role = config.roles.find((item) => item.id === roleId);
    if (!selectedValue || !role) return null;

    return role.variants.find((variant) => String(variant.id) === selectedValue);
  }

  function variantProductTitle(role, variant) {
    return variant && variant.productTitle ? variant.productTitle : role.productTitle;
  }

  function variantDisplayTitle(role, variant) {
    return `${variantProductTitle(role, variant)} - ${variant.title}`;
  }

  function getMatchingToolItems(config) {
    const needleSizeKeys = patternNeedleSizeKeys(config);
    if (!needleSizeKeys.length || !Array.isArray(config.toolProducts)) return [];

    return config.toolProducts.flatMap((toolProduct) => {
      if (getToolSizeOptionIndex(toolProduct) < 0 || !Array.isArray(toolProduct.variants)) return [];

      return toolProduct.variants
        .filter((variant) => toolVariantHasMatchingSize(toolProduct, variant, needleSizeKeys))
        .map((variant) => ({ product: toolProduct, variant }));
    });
  }

  function getSelectedToolItems(builder, config) {
    const selectedIds = Array.from(builder.querySelectorAll('[data-kit-builder-tool]:checked:not(:disabled)'))
      .map((input) => input.value);
    if (!selectedIds.length) return [];

    return getMatchingToolItems(config).filter((item) => selectedIds.includes(String(item.variant.id)));
  }

  function yarnAddOnQuantityForRole(builder, roleId) {
    const input = builder.querySelector(`[data-kit-builder-yarn-addon="${roleId}"]`);
    const quantity = Number(input ? input.value : 0);

    if (!Number.isFinite(quantity)) return 0;
    return Math.max(0, Math.floor(quantity));
  }

  function maxYarnAddOnQuantity(variant, includedQuantity) {
    if (!variant || !variant.available) return 0;
    if (variant.inventoryManagement !== 'shopify') return null;
    if (variant.inventoryPolicy === 'continue') return null;

    return Math.max(0, Number(variant.inventoryQuantity || 0) - Number(includedQuantity || 0));
  }

  function getSelectedYarnAddOnItems(builder, config) {
    const sizeSelect = builder.querySelector(selectors.size);
    const selectedSize = getSelectedSize(config, sizeSelect);

    return config.roles.map((role) => {
      const includedQuantity = roleQuantity(role.id, selectedSize);
      if (includedQuantity <= 0) return null;

      const variant = getSelectedVariant(builder, role.id, config);
      const quantity = yarnAddOnQuantityForRole(builder, role.id);
      if (!variant || quantity <= 0) return null;

      return {
        role,
        variant,
        quantity,
        includedQuantity,
      };
    }).filter(Boolean);
  }

  function findRoleVariantByVariantId(config, variantId) {
    for (const role of config.roles || []) {
      const variant = (role.variants || []).find((roleVariant) => Number(roleVariant.id) === Number(variantId));
      if (variant) return { role, variant };
    }

    return null;
  }

  function findToolItemByVariantId(config, variantId) {
    return (config.toolProducts || []).flatMap((toolProduct) => {
      return (toolProduct.variants || []).map((variant) => ({ product: toolProduct, variant }));
    }).find((toolItem) => Number(toolItem.variant.id) === Number(variantId));
  }

  function roleQuantity(roleId, selectedSize) {
    if (!selectedSize) return 0;
    if (selectedSize.quantities && selectedSize.quantities[roleId] !== undefined) {
      return Number(selectedSize.quantities[roleId] || 0);
    }
    if (roleId === 'main') return Number(selectedSize.mainQuantity || 0);
    if (roleId === 'companion') return Number(selectedSize.companionQuantity || 0);
    if (roleId === 'third') return Number(selectedSize.thirdQuantity || 0);
    return 0;
  }

  function requiredYarnRoles(config, selectedSize) {
    return (config.roles || []).filter((role) => roleQuantity(role.id, selectedSize) > 0);
  }

  function ensureActiveYarnRole(builder, config, selectedSize) {
    const requiredRoles = requiredYarnRoles(config, selectedSize);
    if (!requiredRoles.length) {
      builder.dataset.activeYarnRoleId = '';
      return '';
    }

    const activeRoleId = builder.dataset.activeYarnRoleId;
    if (requiredRoles.some((role) => role.id === activeRoleId)) return activeRoleId;

    builder.dataset.activeYarnRoleId = requiredRoles[0].id;
    return requiredRoles[0].id;
  }

  function updateYarnRoleVisibility(builder, config, selectedSize) {
    const activeRoleId = ensureActiveYarnRole(builder, config, selectedSize);

    builder.querySelectorAll('[data-kit-builder-role-id]').forEach((field) => {
      field.hidden = field.getAttribute('data-kit-builder-role-id') !== activeRoleId;
    });

    builder.querySelectorAll(selectors.yarnRoleTab).forEach((tab) => {
      const isActive = tab.getAttribute('data-kit-builder-yarn-role-tab') === activeRoleId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-pressed', String(isActive));
    });
  }

  function setActiveYarnRole(builder, config, roleId, options) {
    const sizeSelect = builder.querySelector(selectors.size);
    const selectedSize = getSelectedSize(config, sizeSelect);
    const role = (config.roles || []).find((item) => item.id === roleId);
    if (!role || roleQuantity(role.id, selectedSize) <= 0) return;

    builder.dataset.activeYarnRoleId = role.id;
    updateYarnRoleVisibility(builder, config, selectedSize);
    updateYarnSelectionSummary(builder, config, selectedSize);

    if (options && options.scrollOnMobile && window.matchMedia('(max-width: 749px)').matches) {
      const yarnPanel = builder.querySelector('[data-panel-id="yarn"]');
      if (yarnPanel) yarnPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function normalizeMillimeters(value) {
    const normalized = String(value || '').toLowerCase().replace(',', '.');
    const mmMatch = normalized.match(/(\d+(?:\.\d+)?)\s*mm/);
    const numberMatch = mmMatch || normalized.match(/(\d+(?:\.\d+)?)/);
    if (!numberMatch) return '';

    const number = Number.parseFloat(numberMatch[1]);
    if (Number.isNaN(number)) return '';

    return String(Math.round(number * 100) / 100);
  }

  function patternNeedleSizeKeys(config) {
    const sizes = config && config.pattern && Array.isArray(config.pattern.needleSizesMm)
      ? config.pattern.needleSizesMm
      : [];

    return sizes.map(normalizeMillimeters).filter(Boolean);
  }

  function getToolSizeOptionIndex(toolProduct) {
    const options = Array.isArray(toolProduct.options) ? toolProduct.options : [];

    return options.findIndex((option) => {
      const name = String(option || '').toLowerCase();
      return name === 'rozmiar' || name === 'size';
    });
  }

  function toolVariantSizeKey(toolProduct, variant) {
    const sizeOptionIndex = getToolSizeOptionIndex(toolProduct);
    if (sizeOptionIndex < 0 || !Array.isArray(variant.options)) return '';

    return normalizeMillimeters(variant.options[sizeOptionIndex]);
  }

  function toolVariantHasMatchingSize(toolProduct, variant, needleSizeKeys) {
    const sizeKey = toolVariantSizeKey(toolProduct, variant);
    return sizeKey && needleSizeKeys.includes(sizeKey);
  }

  function variantHasEnoughStock(variant, quantity) {
    if (!variant || !variant.available) return false;
    if (quantity <= 0) return true;
    if (variant.inventoryManagement !== 'shopify') return true;
    if (variant.inventoryPolicy === 'continue') return true;

    return Number(variant.inventoryQuantity || 0) >= quantity;
  }

  function preloadSwatchImages(roles) {
    roles.forEach((role) => {
      role.variants.forEach((variant) => {
        if (!variant.swatchImage || variant.swatchImageLoaded) return;

        const image = new Image();
        image.src = variant.swatchImage;
        variant.swatchImageLoaded = true;
      });
    });
  }

  function isReady(builder, config) {
    const sizeSelect = builder.querySelector(selectors.size);
    const selectedSize = getSelectedSize(config, sizeSelect);

    if (!config.pattern.configured || !config.pattern.available || !selectedSize) {
      return false;
    }

    const kitYarnIsReady = config.roles.every((role) => {
      const quantity = roleQuantity(role.id, selectedSize);
      if (quantity <= 0) return true;

      const variant = getSelectedVariant(builder, role.id, config);
      return variantHasEnoughStock(variant, quantity);
    });

    if (!kitYarnIsReady) return false;

    return config.roles.every((role) => {
      const includedQuantity = roleQuantity(role.id, selectedSize);
      const addOnQuantity = yarnAddOnQuantityForRole(builder, role.id);
      if (includedQuantity <= 0 || addOnQuantity <= 0) return true;

      const variant = getSelectedVariant(builder, role.id, config);
      return variantHasEnoughStock(variant, includedQuantity + addOnQuantity);
    });
  }

  function summaryItemHTML(item, config) {
    const priceCents = Number(item.priceCents);
    const hasPrice = Number.isFinite(priceCents);
    const quantityText = item.quantity
      ? label(config, 'itemQuantity', { title: item.title, quantity: item.quantity })
      : item.title;
    const roleText = item.role ? `<span class="kit-builder__summary-role">${escapeHTML(item.role)}:</span> ` : '';

    return `
      <li class="kit-builder__summary-item">
        <span class="kit-builder__summary-item-title">${roleText}${escapeHTML(quantityText)}</span>
        ${hasPrice ? `<span class="kit-builder__summary-item-price">${money(priceCents, config)}</span>` : ''}
      </li>
    `;
  }

  function updateSummary(builder, config) {
    const summary = builder.querySelector(selectors.summary);
    const submit = builder.querySelector(selectors.submit);
    const sizeSelect = builder.querySelector(selectors.size);
    const selectedSize = getSelectedSize(config, sizeSelect);

    if (!summary || !submit) return;

    if (!config.pattern.configured) {
      summary.textContent = label(config, 'summaryNotConfigured');
      submit.disabled = true;
      setSubmitLabel(submit, config, 'addButton');
      return;
    }

    if (!config.sizes.length) {
      summary.textContent = label(config, 'summaryNoSizes');
      submit.disabled = true;
      setSubmitLabel(submit, config, 'addButton');
      return;
    }

    let subtotal = Number(config.pattern.price || 0);
    let discountEligibleSubtotal = subtotal;
    const kitItems = [{
      role: '',
      title: patternDisplayTitle(config),
      quantity: 1,
      priceCents: Number(config.pattern.price || 0),
    }];
    const addOnItems = [];

    config.roles.forEach((role) => {
      const quantity = roleQuantity(role.id, selectedSize);
      if (quantity <= 0) return;

      const variant = getSelectedVariant(builder, role.id, config);
      const displayLabel = usesSingleYarnRole(config) ? '' : roleDisplayLabel(config, role);
      if (!variant) {
        const eligibleVariants = role.variants.filter((item) => variantHasEnoughStock(item, quantity));
        kitItems.push({
          role: displayLabel,
          title: eligibleVariants.length
            ? label(config, 'chooseColour')
            : label(config, 'noColoursForQuantity', yarnQuantityReplacements(config, quantity)),
        });
        return;
      }

      const linePrice = Number(variant.price || 0) * quantity;
      subtotal += linePrice;
      discountEligibleSubtotal += linePrice;
      kitItems.push({
        role: displayLabel,
        title: variantDisplayTitle(role, variant),
        quantity,
        priceCents: linePrice,
      });
    });

    getSelectedYarnAddOnItems(builder, config).forEach((item) => {
      const linePrice = Number(item.variant.price || 0) * item.quantity;
      subtotal += linePrice;
      discountEligibleSubtotal += linePrice;
      addOnItems.push({
        role: label(config, 'yarnAddOnRole'),
        title: variantDisplayTitle(item.role, item.variant),
        quantity: item.quantity,
        priceCents: linePrice,
      });
    });

    getSelectedToolItems(builder, config).forEach((item) => {
      const linePrice = Number(item.variant.price || 0);
      subtotal += linePrice;
      addOnItems.push({
        title: `${item.product.title} - ${item.variant.title}`,
        quantity: 1,
        priceCents: linePrice,
      });
    });

    const sizeText = selectedSize ? selectedSize.label : label(config, 'chooseSize');
    const discount = config.discount || {};
    const discountPercent = Number(discount.percent || 0);
    const hasDiscount = discountPercent > 0;
    const discountAmount = hasDiscount
      ? Math.round(discountEligibleSubtotal * (discountPercent / 100))
      : 0;
    const discountedSubtotal = hasDiscount
      ? subtotal - discountAmount
      : subtotal;
    const discountSummary = hasDiscount
      ? `
        <span class="kit-builder__summary-discount">
          <strong>z kodem: ${money(discountedSubtotal, config)}</strong>
          <span><a class="kit-builder__summary-discount-link" href="https://ig.me/j/AbaI5L-YFnm_gW_x/">Dołącz do KALu</a> i zdobądź 10% zniżki</span>
        </span>
      `
      : '';
    const versionSummary = config.version && config.version.name
      ? `<p class="kit-builder__summary-meta">${escapeHTML(label(config, 'versionLabel'))}: ${escapeHTML(config.version.name)}</p>`
      : '';

    summary.innerHTML = `
      <p class="kit-builder__summary-title"><strong>${escapeHTML(config.pattern.productTitle)}</strong> w rozmiarze ${escapeHTML(sizeText)}</p>
      ${versionSummary}
      <h3 class="kit-builder__summary-heading">${escapeHTML(label(config, 'summaryIncludedHeading'))}</h3>
      <ul class="kit-builder__summary-list">${kitItems.map((item) => summaryItemHTML(item, config)).join('')}</ul>
      ${addOnItems.length ? `
        <h3 class="kit-builder__summary-heading">${escapeHTML(label(config, 'summaryAddOnsHeading'))}</h3>
        <ul class="kit-builder__summary-list">${addOnItems.map((item) => summaryItemHTML(item, config)).join('')}</ul>
      ` : ''}
      <p class="kit-builder__summary-total">
        <span class="kit-builder__summary-total-line">
          <span>${escapeHTML(label(config, 'summaryEstimatedSubtotal'))}</span>
          <strong class="kit-builder__summary-total-amount">${money(subtotal, config)}</strong>
        </span>
        ${discountSummary}
      </p>
    `;

    submit.disabled = !isReady(builder, config);
    setSubmitLabel(submit, config, config.pattern.available ? 'addButton' : 'addButtonUnavailable');
  }

  function updatePanelSummaries(builder, config) {
    const sizeSelect = builder.querySelector(selectors.size);
    const selectedSize = getSelectedSize(config, sizeSelect);
    const sizeSummary = builder.querySelector('[data-kit-builder-panel-summary="size"]');
    const yarnSummary = builder.querySelector('[data-kit-builder-panel-summary="yarn"]');
    const yarnAddOnsSummary = builder.querySelector('[data-kit-builder-panel-summary="yarn-add-ons"]');
    const toolsSummary = builder.querySelector('[data-kit-builder-panel-summary="tools"]');

    if (sizeSummary) {
      sizeSummary.textContent = selectedSize ? selectedSize.label : '';
    }

    const selectedRoles = config.roles.map((role) => {
      const quantity = roleQuantity(role.id, selectedSize);
      if (quantity <= 0) return '';

      const variant = getSelectedVariant(builder, role.id, config);
      return variant
        ? `${usesSingleYarnRole(config) ? '' : `${role.label}: `}${variantDisplayTitle(role, variant)}`
        : '';
    }).filter(Boolean);

    updateYarnSelectionSummary(builder, config, selectedSize);

    if (yarnSummary) {
      yarnSummary.textContent = selectedRoles.join(', ');
    }

    if (yarnAddOnsSummary) {
      yarnAddOnsSummary.textContent = getSelectedYarnAddOnItems(builder, config)
        .map((item) => label(config, 'itemQuantity', {
          title: variantDisplayTitle(item.role, item.variant),
          quantity: item.quantity,
        }))
        .join(', ');
    }

    if (toolsSummary) {
      toolsSummary.textContent = getSelectedToolItems(builder, config)
        .map((item) => `${item.product.title} - ${item.variant.title}`)
        .join(', ');
    }
  }

  function updateYarnSelectionSummary(builder, config, selectedSize) {
    const summary = builder.querySelector(selectors.yarnSummary);
    if (!summary) return;

    const activeRoleId = ensureActiveYarnRole(builder, config, selectedSize);
    const selectedItems = requiredYarnRoles(config, selectedSize).map((role) => {
      const quantity = roleQuantity(role.id, selectedSize);
      const variant = getSelectedVariant(builder, role.id, config);
      const fallbackVariant = role.variants.find((item) => item.image || item.swatchImage) || role.variants[0];
      const imageVariant = variant || fallbackVariant;
      const imageUrl = imageVariant && (imageVariant.image || imageVariant.swatchImage);
      const variantTitle = variant ? variant.title : label(config, 'chooseColour');
      const activeClass = role.id === activeRoleId ? ' is-active' : '';
      const desktopRoleLabel = usesSingleYarnRole(config)
        ? ''
        : `<span class="kit-builder__yarn-summary-role kit-builder__yarn-summary-role--desktop">${escapeHTML(role.label)}</span>`;
      const mobileRoleLabel = usesSingleYarnRole(config)
        ? ''
        : `<span class="kit-builder__yarn-summary-role kit-builder__yarn-summary-role--mobile">${escapeHTML(role.label)}</span>`;

      const imageContent = imageUrl
        ? `<img src="${escapeHTML(imageUrl)}" alt="" loading="lazy">`
        : `<span>${escapeHTML((variantProductTitle(role, imageVariant) || role.label || '').charAt(0))}</span>`;

      return `
        <button
          type="button"
          class="kit-builder__yarn-summary-item${activeClass}"
          data-kit-builder-yarn-role-tab="${escapeHTML(role.id)}"
          data-testid="kit-builder-yarn-role-card"
          aria-pressed="${role.id === activeRoleId ? 'true' : 'false'}"
        >
          ${desktopRoleLabel}
          <div class="kit-builder__yarn-summary-image" aria-hidden="true">
            ${imageContent}
          </div>
          <span class="kit-builder__yarn-summary-copy">
            ${mobileRoleLabel}
            <span class="kit-builder__yarn-summary-product">${escapeHTML(variant ? variantProductTitle(role, variant) : role.productTitle)}</span>
            <span class="kit-builder__yarn-summary-variant">${escapeHTML(variantTitle)}</span>
          </span>
          <span class="kit-builder__yarn-summary-quantity">x${quantity}</span>
        </button>
      `;
    }).filter(Boolean);

    summary.innerHTML = selectedItems.join('');
    summary.hidden = !selectedItems.length;
    updateYarnRoleVisibility(builder, config, selectedSize);
  }

  function renderSizes(builder, config) {
    const sizeSelect = builder.querySelector(selectors.size);
    if (!sizeSelect) return;

    sizeSelect.innerHTML = config.sizes
      .map((size) => `<option value="${size.id}">${escapeHTML(size.label)}</option>`)
      .join('');
  }

  function renderYarnSwatch(config, role, variant, index, selectedValue, quantity) {
    const id = `KitBuilderRole-${config.sectionId}-${role.id}-${index}`;
    const hasEnoughStock = variantHasEnoughStock(variant, quantity);
    const checked = hasEnoughStock && String(variant.id) === selectedValue ? ' checked' : '';
    const disabled = hasEnoughStock ? '' : ' disabled class="disabled"';
    const availableQuantity = Math.max(0, Number(variant.inventoryQuantity || 0));
    const unavailableStockLabel = stockTooltipLabelKey(config, availableQuantity);
    const unavailableStockText = label(config, unavailableStockLabel, { title: variant.title, count: availableQuantity });
    const unavailableStockSuffix = unavailableStockText.replace(variant.title, '').replace(/^:\s*/, '');
    const tooltipText = hasEnoughStock
      ? variant.title
      : unavailableStockText;
    const hiddenAvailabilityText = hasEnoughStock
      ? label(config, 'hiddenColour')
      : `: ${unavailableStockSuffix}`;
    const swatchStyle = variant.swatchImage
      ? ` style="background-image: url('${escapeHTML(variant.swatchImage)}'); background-size: cover;"`
      : '';
    const labelClass = variant.swatchImage ? 'color-swatch' : '';
    const labelContent = variant.swatchImage
      ? `<div data-text="${escapeHTML(tooltipText)}" class="color-name-tooltip">&nbsp;</div><span class="visually-hidden">${escapeHTML(tooltipText)}</span>`
      : `${escapeHTML(variant.title)}<span class="visually-hidden">${escapeHTML(hiddenAvailabilityText)}</span>`;

    return `
      <input
        type="radio"
        id="${id}"
        name="KitBuilderRole-${config.sectionId}-${role.id}"
        value="${variant.id}"
        data-kit-builder-role="${role.id}"
        data-testid="kit-builder-yarn-option"
        ${checked}
        ${disabled}
      >
      <label class="${labelClass}" for="${id}" data-option="${escapeHTML(variant.title)}"${swatchStyle}>
        ${labelContent}
      </label>
    `;
  }

  function renderRoles(builder, config) {
    const rolesWrapper = builder.querySelector(selectors.roles);
    const sizeSelect = builder.querySelector(selectors.size);
    const selectedSize = getSelectedSize(config, sizeSelect);
    if (!rolesWrapper) return;

    preloadSwatchImages(config.roles);
    const activeRoleId = ensureActiveYarnRole(builder, config, selectedSize);

    rolesWrapper.innerHTML = config.roles.map((role) => {
      const quantity = roleQuantity(role.id, selectedSize);
      if (quantity <= 0) return '';
      const hidden = role.id === activeRoleId ? '' : ' hidden';

      const existingInput = builder.querySelector(`[data-kit-builder-role="${role.id}"]:checked`);
      const existingSelect = builder.querySelector(`select[data-kit-builder-role="${role.id}"]`);
      const existingValue = existingInput ? existingInput.value : existingSelect ? existingSelect.value : '';
      const eligibleVariants = role.variants.filter((variant) => variantHasEnoughStock(variant, quantity));
      const existingValueIsEligible = eligibleVariants.some((variant) => String(variant.id) === existingValue);
      const selectedValue = existingValueIsEligible ? existingValue : String(eligibleVariants[0] ? eligibleVariants[0].id : '');
      const hasVariantGroups = Array.isArray(role.variantGroups) && role.variantGroups.length > 0;
      const swatches = hasVariantGroups
        ? role.variantGroups.map((group) => {
          const groupVariants = role.variants.filter((variant) => String(variant.productId) === String(group.productId));
          if (!groupVariants.length) return '';

          return `
            <div class="kit-builder__variant-group" data-testid="kit-builder-yarn-variant-group">
              <div class="kit-builder__variant-group-heading">
                <h4 class="kit-builder__variant-group-title">${escapeHTML(group.title)}</h4>
                <p class="kit-builder__variant-group-message">${escapeHTML(group.message)}</p>
              </div>
              <div class="kit-builder__variant-group-swatches">
                ${groupVariants.map((variant) => renderYarnSwatch(config, role, variant, role.variants.indexOf(variant), selectedValue, quantity)).join('')}
              </div>
            </div>
          `;
        }).join('')
        : role.variants.map((variant, index) => renderYarnSwatch(config, role, variant, index, selectedValue, quantity)).join('');

      return `
        <fieldset class="kit-builder__field product-form__input" data-testid="kit-builder-yarn-role" data-kit-builder-role-id="${escapeHTML(role.id)}"${hidden}>
          <legend class="form__label">${escapeHTML(roleDisplayLabel(config, role))}</legend>
          ${swatches || `<p class="kit-builder__empty">${escapeHTML(label(config, 'emptyNoColours', yarnQuantityReplacements(config, quantity)))}</p>`}
          <p class="kit-builder__hint">${escapeHTML(label(config, 'requiresStockHint', yarnQuantityReplacements(config, quantity)))}</p>
        </fieldset>
      `;
    }).join('');

    updateYarnRoleVisibility(builder, config, selectedSize);
  }

  function renderYarnAddOns(builder, config) {
    const addOnsPanel = builder.querySelector(selectors.yarnAddOnsPanel);
    const addOnsWrapper = builder.querySelector(selectors.yarnAddOns);
    const sizeSelect = builder.querySelector(selectors.size);
    const selectedSize = getSelectedSize(config, sizeSelect);
    if (!addOnsPanel || !addOnsWrapper) return;

    const shouldShowPanel = Boolean(config.pattern.configured && selectedSize && config.roles.length);
    addOnsPanel.hidden = !shouldShowPanel;

    if (!shouldShowPanel) {
      addOnsWrapper.innerHTML = '';
      return;
    }

    const addOnRows = config.roles.map((role) => {
      const includedQuantity = roleQuantity(role.id, selectedSize);
      if (includedQuantity <= 0) return '';

      const variant = getSelectedVariant(builder, role.id, config);
      if (!variant) return '';

      const id = `KitBuilderYarnAddOn-${config.sectionId}-${role.id}`;
      const existingQuantity = yarnAddOnQuantityForRole(builder, role.id);
      const maxQuantity = maxYarnAddOnQuantity(variant, includedQuantity);
      const quantity = maxQuantity === null ? existingQuantity : Math.min(existingQuantity, maxQuantity);
      const disabled = maxQuantity === 0 ? ' disabled' : '';
      const maxAttribute = maxQuantity === null ? '' : ` max="${maxQuantity}"`;
      const stateClass = maxQuantity === 0 ? ' kit-builder__yarn-add-on--disabled' : '';
      const stockHint = maxQuantity === null
        ? label(config, 'yarnAddOnUnlimitedStockHint')
        : label(config, 'yarnAddOnStockHint', yarnQuantityReplacements(config, maxQuantity));
      const title = variantDisplayTitle(role, variant);
      const roleLabel = usesSingleYarnRole(config) ? '' : `<span class="kit-builder__yarn-add-on-role">${escapeHTML(roleDisplayLabel(config, role))}</span>`;

      return `
        <div class="kit-builder__yarn-add-on${stateClass}" data-testid="kit-builder-yarn-add-on-option">
          <div class="kit-builder__yarn-add-on-text">
            ${roleLabel}
            <span>${escapeHTML(title)}</span>
            <span class="kit-builder__hint">${escapeHTML(stockHint)}</span>
          </div>
          <div class="kit-builder__yarn-add-on-control">
            <label class="visually-hidden" for="${id}">
              ${escapeHTML(label(config, 'yarnAddOnQuantityLabel'))}: ${escapeHTML(title)}
            </label>
            <quantity-input class="quantity kit-builder__yarn-add-on-quantity">
              <button class="quantity__button no-js-hidden" name="minus" type="button">
                <span class="visually-hidden">${escapeHTML(label(config, 'yarnAddOnQuantityLabel'))}: ${escapeHTML(title)}</span>
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                </svg>
              </button>
              <input
                id="${id}"
                class="quantity__input kit-builder__yarn-add-on-input"
                type="number"
                min="0"
                step="1"
                value="${quantity}"
                data-kit-builder-yarn-addon="${escapeHTML(role.id)}"
                data-testid="kit-builder-yarn-add-on-quantity"
                ${maxAttribute}
                ${disabled}
              >
              <button class="quantity__button no-js-hidden" name="plus" type="button">
                <span class="visually-hidden">${escapeHTML(label(config, 'yarnAddOnQuantityLabel'))}: ${escapeHTML(title)}</span>
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                </svg>
              </button>
            </quantity-input>
          </div>
        </div>
      `;
    }).filter(Boolean);

    addOnsWrapper.innerHTML = addOnRows.length
      ? addOnRows.join('')
      : `<p class="kit-builder__empty">${escapeHTML(label(config, 'emptyYarnAddOns'))}</p>`;
  }

  function renderTools(builder, config) {
    const toolsPanel = builder.querySelector(selectors.toolsPanel);
    const toolsWrapper = builder.querySelector(selectors.tools);
    if (!toolsPanel || !toolsWrapper) return;

    const hasNeedleSizes = patternNeedleSizeKeys(config).length > 0;
    const hasToolProducts = Array.isArray(config.toolProducts) && config.toolProducts.length > 0;
    const shouldShowPanel = hasNeedleSizes && hasToolProducts;
    toolsPanel.hidden = !shouldShowPanel;

    if (!shouldShowPanel) {
      toolsWrapper.innerHTML = '';
      setOpenPanel(builder, null);
      return;
    }

    const matchingItems = getMatchingToolItems(config);
    if (!matchingItems.length) {
      toolsWrapper.innerHTML = `<p class="kit-builder__empty">${escapeHTML(label(config, 'emptyTools'))}</p>`;
      return;
    }

    toolsWrapper.innerHTML = matchingItems.map((item, index) => {
      const id = `KitBuilderTool-${config.sectionId}-${index}`;
      const isAvailable = variantHasEnoughStock(item.variant, 1);
      const disabled = isAvailable ? '' : ' disabled';
      const stateClass = isAvailable ? '' : ' kit-builder__tool-option--disabled';
      const title = `${item.product.title} - ${item.variant.title}`;

      return `
        <div class="kit-builder__tool-option${stateClass}">
          <input
            type="checkbox"
            id="${id}"
            value="${item.variant.id}"
            data-kit-builder-tool
            data-testid="kit-builder-tool-option"
            ${disabled}
          >
          <label for="${id}">
            <span>${escapeHTML(title)}</span>
            <span>${money(item.variant.price, config)}</span>
          </label>
        </div>
      `;
    }).join('');
  }

  function resetBuilder(builder, config) {
    const sizeSelect = builder.querySelector(selectors.size);
    setPostAddActionsVisible(builder, false);

    if (sizeSelect && sizeSelect.options.length) {
      sizeSelect.selectedIndex = 0;
    }
    builder.dataset.activeYarnRoleId = '';

    builder.querySelectorAll('[data-kit-builder-role]').forEach((input) => {
      if (input.type === 'radio') {
        input.checked = false;
      } else {
        input.value = '';
      }
    });
    builder.querySelectorAll('[data-kit-builder-tool]').forEach((input) => {
      input.checked = false;
    });
    builder.querySelectorAll(selectors.yarnAddOn).forEach((input) => {
      input.value = 0;
    });

    setNotice(builder, '', '');
    renderRoles(builder, config);
    renderYarnAddOns(builder, config);
    renderTools(builder, config);
    updateSummary(builder, config);
    updatePanelSummaries(builder, config);
    setStatus(builder, label(config, 'statusReady'));
  }

  function resetForAnotherKit(builder, config) {
    const sizePanel = builder.querySelector('[data-panel-id="size"]');
    const focusTarget = builder.querySelector('[data-panel-id="size"] [data-kit-builder-panel-toggle]')
      || builder.querySelector(selectors.size);

    resetBuilder(builder, config);
    setOpenPanel(builder, sizePanel);
    builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  function setOpenPanel(builder, targetPanel) {
    const panels = builder.querySelectorAll(selectors.panel);

    panels.forEach((panel) => {
      const isOpen = targetPanel && panel === targetPanel;
      const toggle = panel.querySelector(selectors.panelToggle);
      const content = panel.querySelector(selectors.panelContent);

      panel.classList.toggle('is-open', isOpen);
      if (toggle) toggle.setAttribute('aria-expanded', String(isOpen));
      if (content) content.hidden = !isOpen;
    });
  }

  function initAccordion(builder) {
    const panels = builder.querySelectorAll(selectors.panel);
    if (!panels.length) return;

    setOpenPanel(builder, null);

    panels.forEach((panel) => {
      const toggle = panel.querySelector(selectors.panelToggle);
      if (!toggle) return;

      toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        setOpenPanel(builder, isOpen ? null : panel);
      });
    });
  }

  function generateKitId(config, selectedSize) {
    const base = config.baseId || 'kit';
    const size = selectedSize && selectedSize.id ? selectedSize.id : 'size';
    const stamp = Date.now().toString(36);
    const random = Math.random().toString(36).slice(2, 8);

    return `${base}-${size}-${stamp}-${random}`;
  }

  function buildItems(builder, config, kitId) {
    const sizeSelect = builder.querySelector(selectors.size);
    const selectedSize = getSelectedSize(config, sizeSelect);

    const baseProperties = {
      _kit_id: kitId,
      _kit_base_id: config.baseId,
      _kit_title: config.kitTitle,
      _kit_size: selectedSize.label,
    };

    if (config.version && config.version.name) {
      baseProperties._kit_version = config.version.name;
    }

    const items = [{
      id: config.pattern.variantId,
      quantity: 1,
      properties: {
        ...baseProperties,
        _kit_role: 'pattern',
        _kit_role_label: label(config, 'patternRole'),
        _kit_display_title: patternDisplayTitle(config),
      },
    }];

    config.roles.forEach((role) => {
      const quantity = roleQuantity(role.id, selectedSize);
      if (quantity <= 0) return;

      const variant = getSelectedVariant(builder, role.id, config);
      items.push({
        id: variant.id,
        quantity,
        properties: {
          ...baseProperties,
          _kit_role: role.id,
          _kit_role_label: role.label,
        },
      });
    });

    getSelectedYarnAddOnItems(builder, config).forEach((item) => {
      items.push({
        id: item.variant.id,
        quantity: item.quantity,
        properties: {
          _parent_kit_id: kitId,
          _kit_base_id: config.baseId,
          _kit_title: config.kitTitle,
          _kit_size: selectedSize.label,
          ...(config.version && config.version.name ? { _kit_version: config.version.name } : {}),
          _kit_add_on: 'yarn',
          _kit_add_on_role: item.role.id,
          _kit_role_label: `${label(config, 'yarnAddOnRole')}: ${roleDisplayLabel(config, item.role)}`,
        },
      });
    });

    getSelectedToolItems(builder, config).forEach((item) => {
      items.push({
        id: item.variant.id,
        quantity: 1,
        properties: {
          _parent_kit_id: kitId,
          [label(config, 'toolNoteName')]: label(config, 'toolNoteValue', { pattern: config.pattern.productTitle }),
        },
      });
    });

    return items;
  }

  function describeItem(item, config) {
    if (item.properties && item.properties._kit_role === 'pattern') {
      return `${label(config, 'patternRole')}: ${label(config, 'itemQuantity', { title: config.pattern.productTitle, quantity: item.quantity })} (variant ${item.id})`;
    }

    const roleId = item.properties && item.properties._kit_role;
    if (roleId && String(roleId).startsWith('yarn_add_on_')) {
      const matchingYarn = findRoleVariantByVariantId(config, item.id);
      const title = matchingYarn
        ? `${label(config, 'yarnAddOnRole')}: ${variantDisplayTitle(matchingYarn.role, matchingYarn.variant)}`
        : label(config, 'yarnAddOnRole');

      return `${label(config, 'itemQuantity', { title, quantity: item.quantity })} (variant ${item.id})`;
    }

    const matchingTool = findToolItemByVariantId(config, item.id);
    if (matchingTool) {
      const title = `${label(config, 'toolRole')}: ${matchingTool.product.title} - ${matchingTool.variant.title}`;

      return `${label(config, 'itemQuantity', { title, quantity: item.quantity })} (variant ${item.id})`;
    }

    const role = config.roles.find((itemRole) => itemRole.id === roleId);
    const variant = role ? role.variants.find((roleVariant) => Number(roleVariant.id) === Number(item.id)) : null;
    const title = [
      role ? role.label : roleId,
      role && variant ? variantProductTitle(role, variant) : role ? role.productTitle : '',
      variant ? variant.title : '',
    ].filter(Boolean).join(': ');

    return `${label(config, 'itemQuantity', { title: title || label(config, 'componentFallback'), quantity: item.quantity })} (variant ${item.id})`;
  }

  function buildErrorNotice(error, details) {
    const lines = [
      error.message || label(details && details.config, 'errorCouldNotAdd'),
      details && details.status ? labelledLine(details.config, 'errorHttpStatus', details.status) : '',
      details && details.shopifyStatus ? labelledLine(details.config, 'errorShopifyStatus', details.shopifyStatus) : '',
      details && details.shopifyMessage ? labelledLine(details.config, 'errorShopifyMessage', details.shopifyMessage) : '',
      details && details.shopifyDescription ? labelledLine(details.config, 'errorShopifyDescription', details.shopifyDescription) : '',
      details && details.shopifyErrors ? labelledLine(details.config, 'errorShopifyErrors', details.shopifyErrors) : '',
      details && details.kitId ? labelledLine(details.config, 'errorKitIdAttempted', details.kitId) : '',
    ].filter(Boolean);

    const items = details && details.items ? details.items : [];
    const visibleLines = details && details.config && details.config.debug
      ? lines
      : lines.slice(0, 1);
    if (!visibleLines.length) {
      visibleLines.push(label(details && details.config, 'errorCouldNotAdd'));
    }
    const attemptedLines = details && details.config && details.config.debug && items.length
      ? `<p><strong>${escapeHTML(label(details.config, 'attemptedLines'))}</strong></p><ul>${items.map((item) => `<li>${escapeHTML(item)}</li>`).join('')}</ul>`
      : '';

    return `
      <p><strong>${escapeHTML(label(details && details.config, 'errorHeading'))}</strong></p>
      <ul>${visibleLines.map((line) => `<li>${escapeHTML(line)}</li>`).join('')}</ul>
      ${attemptedLines}
    `;
  }

  function stringifyShopifyErrors(errors) {
    if (!errors) return '';
    if (typeof errors === 'string') return errors;
    if (Array.isArray(errors)) return errors.join(', ');
    if (typeof errors === 'object') {
      return Object.entries(errors).map(([key, value]) => {
        const message = Array.isArray(value) ? value.join(', ') : value;
        return `${key}: ${message}`;
      }).join(', ');
    }

    return String(errors);
  }

  function isShopifyAvailabilityError(state, shopifyErrors) {
    const text = [
      state && state.description,
      state && state.message,
      shopifyErrors,
    ].filter(Boolean).join(' ').toLowerCase();

    return text.includes('availability')
      || text.includes('dostępności')
      || text.includes('not enough')
      || text.includes('sold out')
      || text.includes('out of stock');
  }

  function buildValidationNotice(builder, config) {
    const sizeSelect = builder.querySelector(selectors.size);
    const selectedSize = getSelectedSize(config, sizeSelect);
    const lines = [];

    if (!config.pattern.configured) {
      lines.push(label(config, 'validationMissingData'));
    }

    if (!config.pattern.available) {
      lines.push(label(config, 'validationPatternUnavailable'));
    }

    if (!selectedSize) {
      lines.push(label(config, 'validationChooseSize'));
    }

    config.roles.forEach((role) => {
      const quantity = roleQuantity(role.id, selectedSize);
      if (quantity <= 0) return;

      const variant = getSelectedVariant(builder, role.id, config);
      const eligibleVariants = role.variants.filter((item) => variantHasEnoughStock(item, quantity));

      if (!eligibleVariants.length) {
        lines.push(label(config, 'validationNoColourStock', yarnQuantityReplacements(config, quantity, {
          role: roleDisplayLabel(config, role),
        })));
      } else if (!variant) {
        lines.push(label(config, 'validationChooseColour', { role: roleDisplayLabel(config, role) }));
      } else if (!variantHasEnoughStock(variant, quantity)) {
        lines.push(label(config, 'validationSelectedColourStock', yarnQuantityReplacements(config, quantity, {
          role: roleDisplayLabel(config, role),
        })));
      }
    });

    config.roles.forEach((role) => {
      const includedQuantity = roleQuantity(role.id, selectedSize);
      const addOnQuantity = yarnAddOnQuantityForRole(builder, role.id);
      if (includedQuantity <= 0 || addOnQuantity <= 0) return;

      const variant = getSelectedVariant(builder, role.id, config);
      if (!variantHasEnoughStock(variant, includedQuantity + addOnQuantity)) {
        lines.push(label(config, 'validationYarnAddOnStock', {
          role: roleDisplayLabel(config, role),
          quantity: addOnQuantity,
        }));
      }
    });

    return `
      <p><strong>${escapeHTML(label(config, 'validationHeading'))}</strong></p>
      <ul>${lines.map((line) => `<li>${escapeHTML(line)}</li>`).join('')}</ul>
    `;
  }

  async function removePartialKit(config, kitId) {
    const maxAttempts = 5;

    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
      const cartResponse = await fetch(config.routes.cart);
      const cart = await cartResponse.json();
      const updates = {};

      cart.items.forEach((item) => {
        if (
          item.properties
          && (item.properties._kit_id === kitId || item.properties._parent_kit_id === kitId)
        ) {
          updates[item.key] = 0;
        }
      });

      if (!Object.keys(updates).length) {
        return;
      }

      await fetch(config.routes.cartUpdate, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ updates }),
      });

      await new Promise((resolve) => {
        window.setTimeout(resolve, 200);
      });
    }

    throw new Error(`Partial kit cleanup did not finish for ${kitId}.`);
  }

  function getCartTarget() {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!cart || typeof cart.getSectionsToRender !== 'function') return null;

    return {
      cart,
      sectionIds: cart.getSectionsToRender().map((section) => section.id),
    };
  }

  function normalizeCartStateForRender(cart, state) {
    if (cart.tagName && cart.tagName.toLowerCase() !== 'cart-notification') return state;
    if (state.key || !Array.isArray(state.items) || !state.items.length) return state;

    return {
      ...state,
      key: state.items[0].key,
    };
  }

  async function addKit(builder, config) {
    const sizeSelect = builder.querySelector(selectors.size);
    const selectedSize = getSelectedSize(config, sizeSelect);
    const submit = builder.querySelector(selectors.submit);
    const kitId = generateKitId(config, selectedSize);
    const cartTarget = getCartTarget();
    let added = false;

    submit.disabled = true;
    setSubmitLabel(submit, config, 'addButtonAdding');
    setPostAddActionsVisible(builder, false);
    setNotice(builder, '', '');
    setStatus(builder, label(config, 'statusAdding'));

    try {
      const items = buildItems(builder, config, kitId);
      const payload = {
        items,
      };

      if (cartTarget) {
        payload.sections = cartTarget.sectionIds;
        payload.sections_url = window.location.pathname;
        cartTarget.cart.setActiveElement(document.activeElement);
      }

      const response = await fetch(config.routes.cartAdd, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const state = await response.json();
      if (!response.ok || state.status) {
        const shopifyErrors = stringifyShopifyErrors(state.errors);
        const customerMessage = isShopifyAvailabilityError(state, shopifyErrors)
          ? label(config, 'errorKitStockUnavailable')
          : state.description || shopifyErrors || state.message || response.statusText || label(config, 'errorCouldNotAdd');
        const error = new Error(
          customerMessage
        );
        error.details = {
          config,
          status: response.status,
          shopifyStatus: state.status,
          shopifyMessage: state.message,
          shopifyDescription: state.description,
          shopifyErrors,
          kitId,
          items: items.map((item) => describeItem(item, config)),
        };
        throw error;
      }

      if (cartTarget && state.sections && typeof cartTarget.cart.renderContents === 'function') {
        cartTarget.cart.renderContents(normalizeCartStateForRender(cartTarget.cart, state));
      } else if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kit-builder' });
      }

      added = true;
      setStatus(builder, label(config, 'statusAdded'));
    } catch (error) {
      console.error(error);
      setStatus(builder, label(config, 'statusNotAdded'));

      try {
        await removePartialKit(config, kitId);
      } catch (rollbackError) {
        console.error('Could not clean up partial kit lines.', rollbackError);
      }

      showNoticeHTML(builder, buildErrorNotice(error, error.details || { config, kitId }), 'error');
    } finally {
      updateSummary(builder, config);
      if (added) setPostAddActionsVisible(builder, true);
    }
  }

  function init(builder) {
    const config = parseConfig(builder);
    const form = builder.querySelector(selectors.form);
    if (!config || !form) return;

    builder.setAttribute('data-kit-builder-ready', 'true');
    initAccordion(builder);
    renderSizes(builder, config);
    renderRoles(builder, config);
    renderYarnAddOns(builder, config);
    renderTools(builder, config);
    syncPostAddActions(builder, config);
    updateSummary(builder, config);
    updatePanelSummaries(builder, config);
    setStatus(builder, label(config, 'statusReady'));

    form.addEventListener('change', (event) => {
      if (postAddActionsVisible(builder)) {
        setPostAddActionsVisible(builder, false);
      }

      if (event.target.matches(selectors.size)) {
        renderRoles(builder, config);
        renderYarnAddOns(builder, config);
      }

      if (event.target.matches('[data-kit-builder-role]')) {
        renderYarnAddOns(builder, config);
      }

      updateSummary(builder, config);
      updatePanelSummaries(builder, config);
    });
    form.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const tab = event.target.closest(selectors.yarnRoleTab);
      if (!tab || !form.contains(tab)) return;

      setActiveYarnRole(builder, config, tab.getAttribute('data-kit-builder-yarn-role-tab'), {
        scrollOnMobile: true,
      });
    });
    form.addEventListener('input', (event) => {
      if (!event.target.matches(selectors.yarnAddOn)) return;

      if (postAddActionsVisible(builder)) {
        setPostAddActionsVisible(builder, false);
      }

      updateSummary(builder, config);
      updatePanelSummaries(builder, config);
    });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!isReady(builder, config)) {
        showNoticeHTML(builder, buildValidationNotice(builder, config), 'error');
        setStatus(builder, label(config, 'statusNotReady'));
        return;
      }
      addKit(builder, config);
    });

    const addAnother = builder.querySelector(selectors.addAnother);
    if (addAnother) {
      addAnother.addEventListener('click', () => {
        resetForAnotherKit(builder, config);
      });
    }

    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      resetBuilder(builder, config);
    });
  }

  document.querySelectorAll(selectors.versionGroup).forEach(initVersionGroup);
  document.querySelectorAll('[data-kit-builder]').forEach(init);
})();
